import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/Landing";
import { AdminLogin, AdminDashboard } from "@/Admin";

// Lazy-load heavy / rarely visited routes — keeps the landing-page bundle small.
const AdminContent = lazy(() => import("@/AdminContent"));
const LegalRoute = lazy(() => import("@/Legal"));
const Deck = lazy(() => import("@/Deck"));
const Menu = lazy(() => import("@/Menu"));
const BlogList = lazy(() => import("@/Blog").then(m => ({ default: m.BlogList })));
const BlogPost = lazy(() => import("@/Blog").then(m => ({ default: m.BlogPost })));
const Apply = lazy(() => import("@/Apply"));

const Loading = () => (
  <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">
    <div className="font-mono text-xs tracking-[2px] text-white/40">LOADING...</div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/deck" element={<Deck />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/applypartner" element={<Apply />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/legal" element={<LegalRoute />} />
            <Route path="/legal/:slug" element={<LegalRoute />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
